/* SYNAPIC — header overlays, predictive search, product page, add to cart */
(function () {
  'use strict';

  var cfg = window.synapic || {};

  /* ---------------- money ---------------- */
  function formatMoney(cents, format) {
    format = format || cfg.moneyFormat || '{{amount_with_comma_separator}} zł';
    cents = parseInt(cents, 10) || 0;
    function fmt(number, precision, thousands, decimal) {
      var n = (number / 100).toFixed(precision);
      var parts = n.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = m ? m[1] : 'amount';
    var value;
    switch (key) {
      case 'amount_no_decimals': value = fmt(cents, 0, ',', '.'); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_space_separator': value = fmt(cents, 2, ' ', ','); break;
      case 'amount_no_decimals_with_space_separator': value = fmt(cents, 0, ' ', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2, ',', '.');
    }
    // "money_without_trailing_zeros": drop ,00 / .00
    value = value.replace(/[.,]00$/, '');
    return format.replace(/\{\{\s*\w+\s*\}\}/, value).replace(/<[^>]*>/g, '');
  }

  /* ---------------- overlays (search + menu) ---------------- */
  var openLayer = null;
  var lastFocus = null;

  function openOverlay(el) {
    if (!el) return;
    if (openLayer && openLayer !== el) closeOverlay(openLayer, true);
    lastFocus = document.activeElement;
    clearTimeout(el._syT);
    el.hidden = false;
    el.classList.add('is-open');
    requestAnimationFrame(function () { requestAnimationFrame(function () { el.classList.add('is-visible'); }); });
    document.body.classList.add('sy-lock');
    openLayer = el;
    document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var input = el.querySelector('[data-sy-search-input]');
    if (input) setTimeout(function () { input.focus(); }, 30);
  }
  function closeOverlay(el, keepLock) {
    el = el || openLayer;
    if (!el) return;
    el.classList.remove('is-visible');
    if (el.classList.contains('sy-drawer') && !keepLock) {
      el._syT = setTimeout(function () { el.classList.remove('is-open'); el.hidden = true; }, 320);
    } else {
      el.classList.remove('is-open');
      el.hidden = true;
    }
    document.querySelectorAll('[aria-controls="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!keepLock) document.body.classList.remove('sy-lock');
    if (openLayer === el) openLayer = null;
    if (!keepLock && lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-sy-open]');
    if (opener) {
      e.preventDefault();
      var which = opener.getAttribute('data-sy-open');
      var map = { menu: 'SyMenu', search: 'SySearch', cart: 'SyCart' };
      var target = document.getElementById(map[which]);
      if (!target) { if (opener.href) window.location.href = opener.href; return; }
      openOverlay(target);
      return;
    }
    var closer = e.target.closest('[data-sy-close]');
    if (closer) { e.preventDefault(); closeOverlay(closer.closest('.sy-search, .sy-menu, .sy-drawer')); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && openLayer) closeOverlay(openLayer); });

  /* ---------------- predictive search ---------------- */
  function initSearch() {
    var root = document.querySelector('[data-sy-search]');
    if (!root) return;
    var input = root.querySelector('[data-sy-search-input]');
    var results = root.querySelector('[data-sy-search-results]');
    var clear = root.querySelector('[data-sy-search-clear]');
    var defaultHTML = results.innerHTML;
    var timer, controller;

    function render(q) {
      if (!q) { results.innerHTML = defaultHTML; return; }
      if (controller) controller.abort();
      controller = 'AbortController' in window ? new AbortController() : null;
      results.classList.add('sy-search__loading');
      var url = (window.routes && window.routes.predictiveSearchUrl ? window.routes.predictiveSearchUrl : '/search/suggest') +
        '?q=' + encodeURIComponent(q) +
        '&resources[type]=product,collection,query&resources[limit]=4&resources[options][unavailable_products]=last&section_id=sy-predictive-search';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var node = tmp.querySelector('#sy-predictive');
          results.innerHTML = node ? node.innerHTML : defaultHTML;
          results.classList.remove('sy-search__loading');
        })
        .catch(function () { results.classList.remove('sy-search__loading'); });
    }

    input.addEventListener('input', function () {
      clearTimeout(timer);
      var q = input.value.trim();
      timer = setTimeout(function () { render(q); }, 220);
    });
    if (clear) clear.addEventListener('click', function () { input.value = ''; render(''); input.focus(); });
  }

  /* ---------------- cart helpers ---------------- */
  function addToCart(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || 'Nie udało się dodać do koszyka');
        return data;
      });
    });
  }

  /* ---------------- cart drawer / cart page ---------------- */
  function cartTargets() {
    var t = [];
    document.querySelectorAll('[data-sy-cart-inner]').forEach(function (inner) {
      var host = inner.closest('[data-section-id]');
      if (host) t.push({ id: host.getAttribute('data-section-id'), inner: inner });
    });
    return t;
  }

  function renderCart() {
    var targets = cartTargets();
    if (!targets.length) return Promise.resolve();
    targets.forEach(function (t) { t.inner.classList.add('is-loading'); });
    var ids = targets.map(function (t) { return t.id; }).join(',');
    var base = (window.routes && window.routes.cartUrl) || '/cart';
    return fetch(base + '?sections=' + ids + '&t=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var count = null;
        targets.forEach(function (t) {
          var html = json[t.id];
          t.inner.classList.remove('is-loading');
          if (!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('[data-sy-cart-inner]');
          if (fresh) t.inner.innerHTML = fresh.innerHTML;
          var c = t.inner.querySelector('[data-sy-cart-content]');
          if (c) count = c.getAttribute('data-count');
        });
        if (count !== null) document.querySelectorAll('.CartCountBubble__Count').forEach(function (el) { el.textContent = count; });
        updateProgress();
      })
      .catch(function () { targets.forEach(function (t) { t.inner.classList.remove('is-loading'); }); });
  }

  function afterAdd() {
    var drawer = document.getElementById('SyCart');
    if (drawer) {
      renderCart().then(function () { openOverlay(drawer); });
    } else if (document.querySelector('[data-sy-cartpage]')) {
      renderCart();
    } else {
      window.location.href = (window.routes && window.routes.cartUrl) || '/cart';
    }
  }

  // add-to-cart fired by other theme components (quick add etc.)
  document.addEventListener('product:added', function (e) {
    if (e.detail && e.detail.sySource) return;
    afterAdd();
  });

  document.addEventListener('click', function (e) {
    var q = e.target.closest('[data-sy-qty]');
    if (!q) return;
    e.preventDefault();
    q.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ line: parseInt(q.getAttribute('data-line'), 10), quantity: parseInt(q.getAttribute('data-q'), 10) })
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw new Error(d.description || d.message); });
    }).catch(function (err) { alert(err.message || 'Nie udało się zmienić ilości'); })
      .finally(renderCart);
  });

  var noteTimer;
  document.addEventListener('input', function (e) {
    if (!e.target.matches('[data-sy-note]')) return;
    clearTimeout(noteTimer);
    var val = e.target.value;
    noteTimer = setTimeout(function () {
      fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: val })
      });
    }, 500);
  });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-sy-add]');
    if (!btn) return;
    e.preventDefault();
    btn.disabled = true;
    addToCart(btn.getAttribute('data-sy-add'), 1)
      .then(function () { afterAdd(); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { btn.disabled = false; });
  });

  /* ---------------- free shipping progress ---------------- */
  var progressEls = [];
  var pendingPrice = 0;
  function updateProgress(extraCents) {
    if (typeof extraCents === 'number') pendingPrice = extraCents;
    if (!progressEls.length || !cfg.freeShipping) return;
    fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (cart) {
      var inCart = cart.total_price || 0;
      var threshold = cfg.freeShipping;
      var withProduct = inCart + pendingPrice;
      var text, pct;
      if (inCart >= threshold) {
        text = 'Masz darmową dostawę';
        pct = 100;
      } else if (withProduct >= threshold) {
        text = 'Z tym produktem masz darmową dostawę';
        pct = 100;
      } else {
        text = 'Do darmowej dostawy brakuje ' + formatMoney(threshold - withProduct);
        pct = Math.round(withProduct / threshold * 100);
      }
      progressEls.forEach(function (el) {
        var t = el.querySelector('[data-sy-progress-text]');
        var f = el.querySelector('[data-sy-progress-fill]');
        if (t) t.textContent = text;
        if (f) f.style.width = pct + '%';
      });
    }).catch(function () {});
  }

  /* ---------------- product page ---------------- */
  function initProduct(section) {
    var jsonEl = section.querySelector('[data-sy-product-json]');
    if (!jsonEl) return;
    var product = JSON.parse(jsonEl.textContent);
    var colorIndex = parseInt(section.getAttribute('data-color-index'), 10);
    var form = section.querySelector('form[action*="/cart/add"]');
    var idInput = section.querySelector('[data-sy-variant-input]');
    var atc = section.querySelector('[data-sy-atc]');
    var errorEl = section.querySelector('[data-sy-error]');
    var priceEl = section.querySelector('[data-sy-price]');
    var gallery = section.querySelector('[data-sy-gallery]');
    var dots = section.querySelector('[data-sy-dots]');
    var sticky = section.querySelector('[data-sy-sticky]');
    var optionBlocks = section.querySelectorAll('[data-sy-option]');

    var current = product.variants.find(function (v) { return String(v.id) === String(idInput.value); }) || product.variants[0];
    var selected = current.options.slice();

    section.querySelectorAll('[data-sy-progress]').forEach(function (el) { progressEls.push(el); });
    updateProgress(current.price);

    function findVariant(opts) {
      return product.variants.find(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      });
    }

    function refreshAvailability() {
      optionBlocks.forEach(function (block) {
        var idx = parseInt(block.getAttribute('data-sy-option'), 10);
        block.querySelectorAll('[data-value]').forEach(function (btn) {
          var test = selected.slice();
          test[idx] = btn.getAttribute('data-value');
          var v = findVariant(test);
          var ok = v && v.available;
          btn.classList.toggle('is-unavailable', !ok);
          var isSel = selected[idx] === btn.getAttribute('data-value');
          btn.classList.toggle('is-selected', isSel);
          btn.setAttribute('aria-pressed', isSel ? 'true' : 'false');
        });
        var label = block.querySelector('[data-sy-optval]');
        if (label) label.textContent = selected[idx];
      });
    }

    function priceHTML(v) {
      var html = '';
      if (v.compare_at_price && v.compare_at_price > v.price) html += '<span class="sy-card__compare">' + formatMoney(v.compare_at_price) + '</span>';
      return html + formatMoney(v.price);
    }

    function scrollToMedia(v) {
      if (!v || !v.featured_media || !gallery) return;
      var target = gallery.querySelector('[data-media-id="' + v.featured_media.id + '"]');
      if (!target) return;
      if (window.matchMedia('(max-width: 989px)').matches) {
        gallery.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
      } else {
        var top = target.getBoundingClientRect().top + window.pageYOffset - 80;
        if (Math.abs(top - window.pageYOffset) > 200) window.scrollTo({ top: top, behavior: 'smooth' });
      }
    }

    function updateSticky(v) {
      if (!sticky) return;
      var t = sticky.querySelector('[data-sy-sticky-title]');
      var s = sticky.querySelector('[data-sy-sticky-sub]');
      var img = sticky.querySelector('[data-sy-sticky-img]');
      if (t) t.textContent = product.title + (product.variants.length > 1 ? ' · ' + v.options[v.options.length - 1] : '');
      if (s) s.textContent = (colorIndex >= 0 ? v.options[colorIndex] + ' · ' : '') + formatMoney(v.price);
      if (img && v.featured_image) img.innerHTML = '<img src="' + v.featured_image.src + (v.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=120" alt="">';
      var sb = sticky.querySelector('[data-sy-sticky-btn]');
      if (sb) sb.disabled = !v.available;
    }

    function applyVariant(v, fromColor) {
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }
      if (!v) {
        atc.disabled = true;
        atc.textContent = 'Niedostępne';
        return;
      }
      current = v;
      idInput.value = v.id;
      atc.disabled = !v.available;
      atc.textContent = v.available ? 'Dodaj do koszyka — ' + formatMoney(v.price) : 'Wyprzedane';
      if (priceEl) priceEl.innerHTML = priceHTML(v);
      updateSticky(v);
      updateProgress(v.price);
      if (fromColor) scrollToMedia(v);
      if (window.history && window.history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }

    optionBlocks.forEach(function (block) {
      var idx = parseInt(block.getAttribute('data-sy-option'), 10);
      block.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-value]');
        if (!btn) return;
        selected[idx] = btn.getAttribute('data-value');
        var v = findVariant(selected);
        // colour change → if combination missing, fall back to first available variant of that colour
        if ((!v || !v.available) && idx === colorIndex) {
          var alt = product.variants.find(function (x) { return x.options[idx] === selected[idx] && x.available; });
          if (alt) { selected = alt.options.slice(); v = alt; }
        }
        refreshAvailability();
        applyVariant(v, idx === colorIndex);
      });
    });
    refreshAvailability();

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!current || !current.available) return;
        atc.disabled = true;
        var label = atc.textContent;
        atc.textContent = 'Dodawanie…';
        addToCart(current.id, 1)
          .then(function () { atc.textContent = 'Dodano'; setTimeout(function () { atc.textContent = label; atc.disabled = false; }, 1400); afterAdd(); })
          .catch(function (err) {
            atc.textContent = label; atc.disabled = false;
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          });
      });
    }

    /* mobile gallery dots */
    if (gallery && dots) {
      var spans = dots.querySelectorAll('span');
      gallery.addEventListener('scroll', function () {
        var i = Math.round(gallery.scrollLeft / gallery.clientWidth);
        spans.forEach(function (s, n) { s.classList.toggle('is-active', n === i); });
      }, { passive: true });
    }

    /* sticky bar: visible when main button is off-screen (above) */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          var passed = !en.isIntersecting && en.boundingClientRect.top < 0;
          sticky.classList.toggle('is-visible', passed);
          sticky.setAttribute('aria-hidden', passed ? 'false' : 'true');
          var sb = sticky.querySelector('[data-sy-sticky-btn]');
          if (sb) sb.tabIndex = passed ? 0 : -1;
        });
      });
      io.observe(atc);
      var sbtn = sticky.querySelector('[data-sy-sticky-btn]');
      if (sbtn) sbtn.addEventListener('click', function () {
        if (form.requestSubmit) form.requestSubmit(); else atc.click();
      });
    }
  }

  /* ---------------- recommendations ---------------- */
  function initReco(el) {
    var url = el.getAttribute('data-url');
    if (!url || el.querySelector('.sy-grid')) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div');
      tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-sy-reco]');
      if (inner && inner.innerHTML.trim()) el.innerHTML = inner.innerHTML;
    }).catch(function () {});
  }

  /* ---------------- glass header state ---------------- */
  function initHeaderScroll() {
    var wrap = document.querySelector('[data-sy-headerwrap]');
    if (!wrap) return;
    var ticking = false;
    function update() { wrap.classList.toggle('is-scrolled', window.pageYOffset > 8); ticking = false; }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function init() {
    initHeaderScroll();
    initSearch();
    document.querySelectorAll('[data-sy-product]').forEach(initProduct);
    document.querySelectorAll('[data-sy-reco]').forEach(initReco);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-sy-product]').forEach(initProduct);
    e.target.querySelectorAll('[data-sy-reco]').forEach(initReco);
    if (e.target.querySelector('[data-sy-search]')) initSearch();
  });
})();
